import { FC } from "react";
import { OfferType } from "../types/SellTradeForm.types";

type Props = {
  data: OfferType;
};

export const OffererInfo: FC<Props> = ({ data }) => {
  return (
    <div className="info-container">
      <span className="info-label">
        {"Your information is kept private and secure."}
      </span>
      <span className="input-label">{`${data?.firstName} ${data?.lastName}`}</span>
      <span className="input-label">{data?.email}</span>
      <span className="input-label">{data?.phone}</span>
    </div>
  );
};
